import { useEffect } from 'react';
import { getUserAgent } from 'helpers';

function useViewport() {
	const { os } = getUserAgent();
	const isIOS = os.name === 'iOS';

	//Disable auto zoom on inputs for all ios browsers
	useEffect(() => {
		const content = `width=device-width, initial-scale=1${
			isIOS ? ', maximum-scale=1' : ''
		}`;
		const existingViewportTag = document.head.querySelector(
			'meta[name="viewport"]'
		);
		if (existingViewportTag) {
			existingViewportTag.content = content;
		} else {
			const metaElement = document.createElement('meta');
			metaElement.name = 'viewport';
			metaElement.content = content;
			document.head.appendChild(metaElement);
		}
		// eslint-disable-next-line
	}, []);

	return { isIOS };
}

export default useViewport;
